import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { IconButton, InputAdornment, Stack } from '@mui/material';
import { __permissions, __snackBarSeverity, __snackBarText } from '../../constants';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import { addSubAdmin, getRolesListing } from '../../Controllers/RoleManagement';
import mainContext from '../../contexts/mainContext';
import SelectDialCode from '../Common/SelectDialCode';
import { requestValidator } from '../../utils';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const RegisterForm = ({ open, handleClose, onAdd }) => {
    const { setSnackBar, setPageload } = React.useContext(mainContext);
    const [showPassword, setShowPassword] = useState(false);
    const [state, setState] = useState({
        supportRoles: [],
        role: null,
        roleId: 0,
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        file: "",
        dialCode: "",
        mobileNo: ""
    })

    const [mobileNumber, setMobileNumber] = useState("");
    useEffect(() => {
        getRoles()
        return () => { }
    }, [])


    const getRoles = async () => {
        const res = await getRolesListing();
        if (res.data.status === 200) {
            setState({ ...state, ...res.data.data, load: false })
        } else {
            setState({ ...state, load: false, error: res.data.message })
        }
    }

    const handleAdd = async () => {
        const requestMap = {
            firstName: state.firstName,
            lastName: state.lastName,
            email: state.email,
            password: state.password,
            dialCode: "+" + mobileNumber?.country?.dialCode,
            mobileNo: mobileNumber?.phone?.replace(mobileNumber?.country?.dialCode, ""),
            roleId: state.roleId,
            pic: state.file
        }
        const validate = requestValidator(requestMap)
        if (!validate.isValid) {
            return setSnackBar({
                status: true,
                text: "All field are required",
                severity: __snackBarSeverity.error
            });
        }
        setPageload(true)
        const res = await addSubAdmin(validate.formdata);
        setPageload(false)
        if (res.data.status === 200) {
            setSnackBar({
                status: true,
                text: res.data.message,
                severity: __snackBarSeverity.success
            });
            handleClose()
            onAdd(res.data.data)
        } else {
            setSnackBar({
                status: true,
                text: res.data.message,
                severity: __snackBarSeverity.error
            });
        }
    }

    return (
        <>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add new</DialogTitle>
                <DialogContent>
                    <Stack spacing={3}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} style={{ marginTop: "1rem" }}>
                            <TextField
                                fullWidth
                                label="First name"
                                id='firstName'
                                inputProps={{ maxLength: 30 }}
                                onChange={(e) => setState({ ...state, firstName: e.target.value })}
                            />

                            <TextField
                                fullWidth
                                label="Last name"
                                id='lastName'
                                inputProps={{ maxLength: 30 }}
                                onChange={(e) => setState({ ...state, lastName: e.target.value })}
                            />

                        </Stack>

                        <TextField
                            fullWidth
                            autoComplete="email"
                            type="email"
                            label="Email address"
                            id='email'
                            inputProps={{ maxLength: 50 }}
                            onChange={(e) => setState({ ...state, email: e.target.value })}
                        />
                        <TextField
                            autoComplete="current-password"
                            onChange={(e) => setState({ ...state, password: e.target.value })}
                            type={showPassword ? 'text' : 'password'}
                            label="Password"
                            InputProps={{
                                maxLength: 30,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => { setShowPassword(!showPassword) }}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                        <SelectDialCode setMobileNumber={setMobileNumber} />

                        <h5>Profile picture</h5>
                        <TextField
                            id='profilePicture'
                            fullWidth
                            autoComplete="profilePicture"
                            type="file"
                            inputProps={{ accept: "image/*" }}
                            onChange={(e) => setState({ ...state, file: e.target.files[0] })}
                        />

                        <FormControl sx={{ m: 1 }}>
                            <InputLabel id="role">Role</InputLabel>
                            <Select
                                labelId="role"
                                id="role"
                                value={state.role}
                                onChange={(e) => setState({ ...state, role: e.target.value, roleId: e.target?.value?.split("#")[1] })}
                                input={<OutlinedInput label="Role" />}
                                MenuProps={MenuProps}
                            >
                                {state.supportRoles.map((object) => (
                                    <MenuItem
                                        key={object.role}
                                        value={object.role + "#" + object._id}>
                                        {object.role}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Stack>
                    <div style={{
                        marginTop: "1rem",
                        display: "flex",
                        columnGap: "1rem"
                    }}>
                        <Button type='submit' variant="contained" size="small" onClick={handleAdd}>Register</Button>
                        <Button onClick={handleClose} size="small" >Cancel</Button>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
}


export default RegisterForm